import { ReviewScoreScale } from '@smooved/core';

export const filterUnanswered = { unanswered: true };
export const filterBadGoodBuckets = { buckets: `${ReviewScoreScale.Bad},${ReviewScoreScale.Poor}` };
